import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'

import type { PermissionsDispatch, PermissionsState, PermissionsType } from './reducers/permissions'
import { initialPermissionsState } from './reducers/permissions'

type Context = [PermissionsState, PermissionsDispatch]

const { context: PermissionsContext, hook: usePermissions } = createContext<Context>()

interface ProviderType {
  permissions?: PermissionsType
}

const noop: PermissionsDispatch = () => {}

const PermissionsProvider = ({ permissions, children }: React.PropsWithChildren<ProviderType>) => {
  const state = React.useMemo(() => initialPermissionsState({ permissions }), [permissions])

  const value = React.useMemo<Context>(() => [state, noop], [state])

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>
}

export { PermissionsProvider, usePermissions }
